const specs = reactive({});

export const userSeedSpecs = async () => {
    if (!Object.keys(specs).length) {
        const { data } = await useGetSeedSpecsQuery();

        for (let param of data.value.uogorod_seed_specs) {
            specs[param.name] = param; 
        }
    }
    
    return {
        specs
    }
}